// @ts-strict-ignore
import { typedWindow } from './types'

export function go() {
  if (typedWindow.ScarabQueue) {
    typedWindow.ScarabQueue.push(['go'])
  }
}
